import { authStore } from "../stores/auth.store";

let logoutTimer;
let watcherActive = false;
let activityHandler;
let unsubscribe;

const activityEvents = [
  "mousemove",
  "keydown",
  "click",
  "scroll",
  "touchstart",
];

const logout = () => {
  authStore.getState().reset();
  const currentPath = encodeURIComponent(window.location.pathname);
  if (!currentPath.startsWith("/login")) {
    window.location.href = `/login?redirect=${currentPath}`;
  }
};

const resetTimers = () => {
  clearTimeout(logoutTimer);
  const { refreshTokenExpiryTime } = authStore.getState();
  if (!refreshTokenExpiryTime) return;
  const expiryTime = new Date(refreshTokenExpiryTime).getTime();
  if (isNaN(expiryTime)) return;
  const timeLeft = expiryTime - Date.now();

  if (timeLeft <= 0) {
    logout();
  } else {
    // Auto logout at expiry
    logoutTimer = setTimeout(logout, timeLeft);
  }
};
export const startInactivityWatcher = () => {
  if (watcherActive) return;
  watcherActive = true;

  // Reset timer on user activity
  activityHandler = resetTimers;
  activityEvents.forEach((event) =>
    window.addEventListener(event, activityHandler)
  );
  // Reset timer when refreshTokenExpiryTime changes in store
  unsubscribe = authStore.subscribe(
    (state) => state.refreshTokenExpiryTime,
    () => resetTimers()
  );
  resetTimers();
};

export const stopInactivityWatcher = () => {
  if (!watcherActive) return;
  watcherActive = false;

  clearTimeout(logoutTimer);

  if (activityHandler) {
    activityEvents.forEach((event) =>
      window.removeEventListener(event, activityHandler)
    );
  }
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }
};
